export const DARK_COLOR_TYPE = 'dark';
export const LIGHT_COLOR_TYPE = 'light';
export const ACCENT_COLOR_TYPE = 'accent';

export const SOLID_COLOR_TYPE = 'solid';
export const GRADIENT_COLOR_TYPE = 'gradient';

export const LIGHT_CR_THRESHOLD = 3;
